export const TOUR_ADMIN = "tour_admin"
export const TOUR_OPERATOR = "tour_operator"
export const RENTAL_ADMIN = "rental_admin"
export const RENTAL_OPERATOR = "rental_operator"
export const TOUR_MODULE = "tour"
export const RENTAL_MODULE = "rental"